import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledHeaderAccordion = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
});
export const StyledInfoDocument = styled(Box)({
  textTransform: "uppercase",
  fontSize: 12,
  fontWeight: 600,
});
export const StyledSummaryHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: 8,
  flexGrow: 1,
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 0,
    "& p": {
      fontSize: "0.8rem",
    },
    "& h2": {
      fontSize: "1rem",
    },
  },
}));
export const StyledLoadingContainer = styled(Box)(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(255,255,255,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 2,
  zIndex: 9999,
}));
